import {jwtDecode} from "jwt-decode";

// Controleer of de gebruiker toegang heeft tot een specifieke walletCode
export const hasAccessToDashboard = (token, walletCode) => {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    return decoded.dashboards?.includes(walletCode);
  } catch (error) {
    console.error("Invalid token", error);
    return false;
  }
};

// Roles the token says the user holds on one wallet. Good enough to decide what
// to render; every route that matters checks the same thing server side.
export const getWalletRoles = (token, walletCode) => {
  if (!token) return [];

  try {
    const decoded = jwtDecode(token);

    return decoded.wallets?.find((wallet) => wallet.walletCode === walletCode)?.roles ?? [];
  } catch (error) {
    console.error("Invalid token", error);
    return [];
  }
};

export const isWalletAdmin = (token, walletCode) =>
  getWalletRoles(token, walletCode).includes("admin");

// The wallets and companies the token says the user is a member of. Enough to
// decide whether to offer the beheer-navigatie at all, and to link straight to
// a wallet without another round trip.
export const getWalletMemberships = (token) => {
  if (!token) return [];

  try {
    return jwtDecode(token).wallets ?? [];
  } catch (error) {
    console.error("Invalid token", error);
    return [];
  }
};

export const getDashboards = (token) => {
  if (!token) return [];

  try {
    return jwtDecode(token).dashboards ?? [];
  } catch (error) {
    console.error("Invalid token", error);
    return [];
  }
};

export const canReachAdmin = (token) => getDashboards(token).length > 0;

const roleLabels = {
  admin: "Beheerder",
  logistics: "Logistiek",
  staff: "Medewerker",
};

const roleOrder = ["admin", "logistics", "staff"];

export const labelRoles = (roles = []) =>
  [...new Set(roles)]
    .sort((a, b) => roleOrder.indexOf(a) - roleOrder.indexOf(b))
    .map((role) => roleLabels[role] ?? role)
    .join(" en ");
